<script lang="ts" setup>
import { MenuItem } from '@headlessui/vue'

const props = defineProps<{
    active?: boolean
    disabled?: boolean
}>()
</script>

<template>
    <MenuItem
        class="hover:bg-stone-200 hover:dark:bg-stone-600"
        :class="{ 'pointer-events-none opacity-40': props.disabled }"
    >
        <button
            :class="{ 'bg-green-500 text-white': props.active }"
            class="flex w-full items-center py-2 px-3 text-sm dark:text-primary-100"
        >
            <slot />
        </button>
    </MenuItem>
</template>
